import React from 'react';
import { connect } from 'react-redux';
import SearchField from './SearchField';
// import MuiSimpleSelect from './menus/MuiSimpleSelect';
import EventFilterMenu from './menus/EventFilterMenu';
import { updateEventListFilter } from '../actions/picapp';
import { startGetEventsInvitedTo } from '../actions/event';
import  { prtStart, prtEnd, prtInput, prtStep, prtVar, prtOutput, prtErr } from "../utils/prt"; 

let TRACE = true;
var COMP_NAME = "PicEventsSearchBar";


// This SearchBar component is used to wrap the SearchField and the EventListFilter (displayed as a label).
// The two function props, onSubmit and registrationFunction are required by the SearchField component and 
// they must be passed to this component, from the Dashboard, so they can be propagated to the SearchField. Below find 
// the component  hierarchy :  Dashboard -> PicEventsSearchBar -> EventFilterMenu + SearchField
//
// With Regard to the EventListFilter, this component is responsible for 
//   1. picking up the default eventListFilter value (eg All My Events, Events Invited To) set on the redux store  
//   2. rendering it as the searchBar title for this component via the <EventFilterMenu> component
//
// If user clicks on EventFilterMenu (which is also the SearchBar label) and selects another menu item (e.g. Events Invited To ), 
// that change would result in the following.
//   1. dispatch the action "startGetEventsInvitedTo". This action will call the api and populate redux store with Events Invited To list
//   2. When api call successfully completes, the same action will dispatch another action, "updateEventListFilter", to let both
//      the PicEventsSearch bar and Dashboard know that the user chose another filter (eg Events Invite To), and data is ready
//      on the redux store for display.
//
// Why trigger the fetch data from this component and not the DashBoard?
//   The dashboard already has alot of code and a number of api calls, including calculating metrics. I did not want to increase
//   the wait time for user before they can view the dashboard results. Since the Events Invited To list need not show up 
//   on initial renderng of dashboard, I have chose to defer fetching "EventsInvitedTo" data until user selects that option,
//   which would have with this component.


// T O D O S
// When a particular selection is made, think about setting the selectedName in the toggle and using the numeric value
// in the redux store.
// As first step, make the change to see if I can convert string in redux store to number value.
// If above works, find location to apply filter on date (eg past events).
// After that,see how to work with date in order to use date-fns for the filtering logic.


const PicEventsSearchBar = (props) => {
    //TRACE && prtStart(COMP_NAME, 'PicventsSearchBar');

    // Initialized drop down list values
    const ddlist = [
        {key: 0, title: "All My Events",         selected: false, listname: "filters"}, 
        {key: 1, title: "My Upcoming Events",   selected: false, listname: "filters"}, 
        {key: 2, title: "My Past Events",       selected: false, listname: "filters"}, 
        {key: 3, title: "Events Invited To", selected: false, listname: "filters"} 
    ];

    /* Set eventListFilter to show selected events on Dashboard. Primary can be  "My Events" or "Events Invited To". '
       Secondary can be "My Past Events" or "My Upcoming Events" */
    let eventListFilter = props.picapp.filters.eventListFilter ? props.picapp.filters.eventListFilter : "All My Events";
    
    // let eventListFilter = props.picapp.filters.eventListFilter ? props.picapp.filters.eventListFilter : { eventListFilterPrimary: 0, eventListFilterSecondary: 0 }

    /* toggleSelected handler is used to provide item selected from drop down. The value selected is used to set eventListFilter */
    function toggleSelected (key, listname) {
        
        /* set eventListFilter; No need to load MyEvents as those get loaded by default when you first log into application and render Dashboard. */ 
        if (key === 0) { 
            //TRACE && console.log('inside key === 0 test')
            eventListFilter = "All My Events";
        }
        if (key === 1) { 
            //TRACE && console.log('inside key === 1 test')
            eventListFilter = "My Upcoming Events";
        }
        if (key === 2) { 
            //TRACE && console.log('inside key === 1 test')
            eventListFilter = "My Past Events";
        }
        /* Set eventListFilter and call function to dispatch event to load eventsInvitedTo */
        if (key === 3 ) { 
            //TRACE && console.log('inside key === 3 test')
            eventListFilter = "Events Invited To";
            props.startGetEventsInvitedTo();  
        };

        /* Update eventListFilter on redux store so components like PicEventsSearchBar and DashBoard table component can reflect changes on UI */
        console.log('Calling updateEventListFilter with this value ', eventListFilter )
        props.updateEventListFilter(eventListFilter);
    }
   
        
    //TRACE && prtVar('eventListFilter', eventListFilter);

    return (
        <div className="events-searchbar">
            {/*<p className="events-searchbar-elem-1">Events</p> */}
            <div className="events-searchbar-elem-1">
                <EventFilterMenu title={eventListFilter} list={ddlist} 
                    config={{displayHeader: true, upDownArrow: false}}
                    toggleSelected={toggleSelected} 
                />
            </div>
            <div className="events-searchbar-elem-2">
                <SearchField 
                    onSubmit = {props.onSubmit}
                    registrationFunction={props.registrationFunction}
                />
            </div>
        </div>
    )

    /* Render SearchBar with EventFilterMenu, as SearchBar label, and search field */
    
}


const mapDispatchToProps = (dispatch) => ({
    updateEventListFilter:   (eventListFilter) => dispatch(updateEventListFilter(eventListFilter)),
    startGetEventsInvitedTo: ()                => dispatch(startGetEventsInvitedTo())
})

const mapStateToProps = (state) => {
  return {
      picapp:  state.picapp
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(PicEventsSearchBar)

// export default PicEventsSearchBar;


// WEBPACK FOOTER //
// ./src/components/PicEventsSearchBar.js